import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Heading from '../../Components/Heading/heading.tsx';

type Props = {
  isOpen: boolean;
  tableData: any[];
  file: File | null;
  tableColumns: any[];
  setFile: (file: File | null) => void;
  setUploadModal: (state: boolean) => void;
  setTableData: (state: any[]) => void;
  setTableColumns: (state: any[]) => void;
  setShowModal: (state: boolean) => void;
};

const UploadPreviewModal: React.FC<Props> = ({
  isOpen,
  tableData,
  tableColumns,
  setUploadModal,
  setTableData,
  setTableColumns,
  file,
  setFile,
  setShowModal,
}) => {
  const [proceedModal, setProceedModal] = useState<boolean>(false);

  const discardData = () => {
    setTableData([]);
    setTableColumns([]);
    setUploadModal(false);
    setShowModal(true);
    setFile(null);
  };

  const handleProceed = () => {
    setProceedModal(true);
    setUploadModal(false);
  };

  const rows = tableData.length > 0 
    ? tableData.map((row, index) => ({ id: index, ...row }))
    : [{ id: 0, 'Order ID': 'No Data' }];

  const columns = tableColumns.map(col => ({
    field: col.field,
    headerName: col.label,
    width: col.width || 150,
    sortable: col.sort !== undefined,
  }));

  return (
    <>
      <Dialog
        open={isOpen}
        onClose={() => setUploadModal(false)}
        maxWidth="xl"
        fullWidth
      >
                         <Box
                                sx={{
                                marginLeft: {
                                    xs: '0px',
                                    sm: '-180px',
                                },
                                
                                }}
                            >
        <Heading title="Upload Preview Modal" closeIcon='true' onClose={discardData}/></Box>
        <DialogContent>
          <Box className="table-container custom-data-grid" sx={{
            position: 'relative',
            overflowY: 'auto',
            height: '60vh'
          }}>
            <DataGrid
              rows={rows}
              columns={columns}
              hideFooterPagination
              disableRowSelectionOnClick
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? "striped-row" : ""
              }
              sx={{
                '& .MuiDataGrid-row': {
                  backgroundColor: '#e7e7e7',
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', px: 3 }}>
          <Button
            variant="outlined"
             className="custom-cancel-button"
            onClick={discardData}
          >
            Discard
          </Button>
          <Button
            variant="contained"
             className="custom-button"
            onClick={handleProceed}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UploadPreviewModal;